import { Provider } from "@angular/core";
import { DataLoadService, DataSearchService } from "./services";

export function provideDataLoad(): Array<Provider>
{
    return [
        DataLoadService,
        DataSearchService,
    ];
}
